// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@synd/Overrides/Widgets/Basic/Logo";
import { xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        width: 248px;
        height: 37px;
        & .home-page-link {
            width: 100%;
            height: 100%;
        }
        ${xScreen("lte", "md")} {
            width: 160px;
        }
        ${xScreen("lt", "sm")} {
            width: 50px;
            height: 40px;
        }
    `,
};

logoStyles.img = {
    css: css`
        width: 100%;
        height: 100%;
    `,
};
